module.exports = __webpack_public_path__ + "static/media/fitness.ac5ee601.png";